import React, { useEffect, useState } from "react";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

import * as Template from "../../templates";
import * as actions from "../../actions";
import { useNavigate, useParams } from "react-router-dom";

export default () => {
  const moduleName = `wholesale_rules`;
  const appReducer = useSelector((state) => state.appReducer, shallowEqual);
  const dispatch = useDispatch();

  const params = useParams()

  const navigate = useNavigate()

  const [id, setId] = useState();

  const [name, setName] = useState(``);
  const [min, setMin] = useState(``);
  const [max, setMax] = useState(``);
  const [discount, setDiscount] = useState(``);

  const [categoryId, setCategoryId] = useState(``);
  const [categories, setCategories] = useState(``);

  const [productPriceId, setProductPriceId] = useState(``);
  const [productPrices, setProductPrices] = useState(``);


  const [submitted, setSubmitted] = useState(false);

  const handleClick = () => {
    if (id != undefined) {
      dispatch(actions.update(id, moduleName));
    } else {
      dispatch(actions.store(moduleName));
    }
    setSubmitted(true)
  };

  useEffect(() => {
    if (appReducer.wholesale_rules_edit != undefined && id != undefined) {
      let row = appReducer.wholesale_rules_edit.data;
      setName(row.name);
      setProductPriceId({
        value: row.wholesale.product_price_id,
        label: `${row.wholesale.product_price.product.name} - ${row.wholesale.product_price.name} - ${row.wholesale.product_price.code}`,
      })
      setMin(row.min)
      setMax(row.max)
      setDiscount(row.discount);
      setCategoryId({
        value: row.wholesale_id,
        label: row.wholesale.name
      });
    }
  }, [appReducer.wholesale_rules_edit]);

  useEffect(() => {
    if (submitted) {
      if (
        (appReducer.wholesale_rules_store != undefined && appReducer.wholesale_rules_store.error == false) ||
        (appReducer.wholesale_rules_update != undefined && appReducer.wholesale_rules_update.error == false)
      ) {
        navigate(-1)
      }
    }
    return () => setSubmitted(false)
  }, [
    appReducer.wholesale_rules_store,
    appReducer.wholesale_rules_update
  ])

  useEffect(() => {
    dispatch(actions.list("product_prices/option"));
  }, []);


  useEffect(() => {
    if (id != undefined) {
      dispatch(actions.edit(id, moduleName));
    }
  }, [id]);

  useEffect(() => {
    if (params.id != undefined) {
      setId(params.id)
    }
  }, [params])


  useEffect(() => {
    if (appReducer.wholesales_option_edit != undefined) {
      setCategories(appReducer.wholesales_option_edit.data);
    }
  }, [appReducer.wholesales_option_edit]);

  useEffect(() => {
    if (appReducer.product_prices_option_list != undefined) {
      setProductPrices(appReducer.product_prices_option_list.data);
    }
  }, [appReducer.product_prices_option_list]);


  const onChange = (value) => setCategoryId(value);

  const onChangeProductPrice = (value) => {
    setProductPriceId(value)
  };

  useEffect(() => {
    if (productPriceId != undefined) {
      dispatch(actions.edit(productPriceId.value, `wholesales/option`));
    }
  }, [productPriceId])

  return <Template.Form>
    <Template.SingleSelect
      withLabel
      required
      placeholder="گروه محصول"
      name="product_price_id"
      value={productPriceId}
      onChange={onChangeProductPrice}
      options={productPrices}
    />
    <Template.SingleSelect
      withLabel
      required
      placeholder="کارتن‌ها"
      name="wholesale_id"
      value={categoryId}
      onChange={onChange}
      options={categories}
    />
    <Template.Input required value={name} label="نام" name="name" type="text" />
    <Template.Input required value={min} label="تعداد از" name="min" type="number" />
    <Template.Input required value={max} label="تعداد تا" name="max" type="text" />
    <Template.Input required value={discount} label="درصد تخفیف" name="discount" type="text" />
    <Template.Button
      label="ذخیره"

      onClick={handleClick}
    />
  </Template.Form>
};